export default "__VITE_ASSET__CWNcnFwr__"